import * as Sentry from "@sentry/react"

import { ApiTypes } from "types"

export const setSentryUserContext = (userProfile: ApiTypes.Model.UserProfile | null) => {
  if (userProfile) {
    Sentry.setUser({
      id: userProfile.id.toString(),
      email: userProfile.email,
    })
  } else {
    Sentry.setUser(null)
  }
}

export const clearSentryUserContext = () => {
  Sentry.setUser(null)
}
